const timestamp = (state = null, action) => {
  switch (action.type) {
    case "SET_TIMESTAMP":
      return Date.now()
    default:
      return state
  }
}

export default timestamp
